import PropTypes from 'prop-types';
import React from 'react';
import useWindowLocationHref from '../../Hooks/useWindowLocation';
const LinkButton = ({ link, linkText, buttonClass, altLinkText }) => {
  const href = useWindowLocationHref();
  return link ? (
    <div
      data-event-category={href || 'novalue'}
      data-event-action={linkText}
      data-event-name="LinkButton"
      className={buttonClass}
      role="button"
      aria-label={linkText ?? 'Läs mer'}
    >
      <a data-event-include href={link}>
        {linkText ?? altLinkText ?? 'Läs mer'}
      </a>
    </div>
  ) : null;
};

LinkButton.propTypes = {
  link: PropTypes.string,
  linkText: PropTypes.string,
  buttonClass: PropTypes.string,
};

export default LinkButton;
